import { render, staticRenderFns } from "./TableauPassages.vue?vue&type=template&id=6967fb16&scoped=true&"
import script from "./TableauPassages.vue?vue&type=script&lang=js&"
export * from "./TableauPassages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967fb16",
  null
  
)

export default component.exports